module.exports = __webpack_public_path__ + "static/img/materials3.3686fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials3.png
// module id = KBxJ
// module chunks = 2